/**
 * 마지막으로 읽은 기기 스토어 국가(alpha-2). 상점 조회가 갱신하고, API 클라이언트가 `X-Storefront-Country` 로 붙인다 —
 * 서버는 가입 때 이 값으로 계정 국가를 1회 판정한다(상점·결제 설계 결정 16). 없으면 헤더를 보내지 않는다. 메모리에만 둔다(캐시 금지, 사용자가 스토어 국가를 바꿀 수 있음).
 */
let known: string | null = null;

export const setKnownStorefront = (region: string | null) => {
  known = region;
};
export const getKnownStorefront = () => known;
